import '../../immer-init';
import '../../dev-console-filter';
import('./bootstrap').catch((err) => console.error(err));
